// eslint-disable-next-line no-unused-vars
const chipCounts = (value, index) => {
  const chips = [];
  switch(value){
    case "0":
      break;
    case "1":
      chips.push("1");
      break;
    case "2":
      chips.push("1","1");
      break;
    case "3":
      chips.push("1","1", "1");
      break;
    case "4":
      chips.push("1","1","1","1");
      break;
    case "5":
      chips.push("5");
      break;
    case "6":
      chips.push("5", "1");
      break;
    case "7":
      chips.push("5", "1", "1");
      break;
    case "8":
      chips.push("5", "1", "1", "1");
      break;
    case "9":
      chips.push("5", "1", "1", "1", "1");
      break;
  }

  const result = [];
  // console.log('chips', chips);
  if(chips.length > 0){
    [...chips].forEach((element) => {
      const value = element + getChipName(index);
      result.push(value);
    });
  }
  
  return result;
};

const getChipName = (index) => {
  switch(index){
    case 1: return "0";
    case 2: return "00";
    case 3:  return "k";
    case 4: return "0k";
    case 5: return "00k";
    case 6:  return "m";
    case 7: return "0m";
    case 8: return "00m";
    default: return "";
  }
}

export const calculateChipStack = (value) => {
  const result = [];
  const n = value.toString().split("").reverse().join("");

  // console.log('n', value, n);
  [...n].forEach((element, index) => {
    // console.log('element', element, index);
    const chips = chipCounts(element, index);
    result.push(...chips);
  });


  // console.log('chips', result);
  return result.reverse();
};
